<template lang="pug" src="./AdminNewUsers.pug"></template>
<script>
import { mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver, localize } from "vee-validate"

import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import en from "vee-validate/dist/locale/en.json";
import es from "vee-validate/dist/locale/es.json";

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      name: '',
      email: '',
      hotspot: '',
      password: '',
      password2: ''
    }
  },
  methods: {
    ...mapActions(['saveUser']),
    async onSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        await this.saveUser({
          role: "admin",
          name: this.name,
          email: this.email,
          password: this.password
          // cadastrar hotspot
        })
      }
    }
  },
  computed: {
    lang(){
      return this.$store.getters.locale
    }
  },
  watch: {
    lang (newLang, oldLang) { // se trocou a linguagem, revalida o form
      const lg = { en: en, pt: pt_BR, es: es };
      localize(`${newLang}`, lg[newLang]);

      this.$refs.form.validate();
    }
  }
}
</script>
